import React, { ReactNode } from 'react';
import { Container, IconContainer, Title } from './Styled';
import NodeTypes from '../../../../../model/workflowEditor/NodeTypes';

type ItemProps = {
  Icon: ReactNode,
  nodeType: NodeTypes,
  title: string
}

const Item: React.FunctionComponent<ItemProps> = ({Icon, nodeType, title}) => {
  return (
   <Container draggable={true} onDragStart={event => {
    event.dataTransfer.setData('storm-diagram-node', JSON.stringify({type: nodeType }));
  }}>
     <IconContainer>
      {Icon}
     </IconContainer>
     <Title>
     <p>{title}</p>
     </Title>
   </Container>
  );
}

export default Item;
